/**
 * Shared overrides so MUI ToggleButton / ToggleButtonGroup borders
 * never flash during selected-state transitions on sliding toggles.
 * Does not change the group's own outer border (callers may keep one).
 */
export const slidingToggleGroupNoBorder = {
  '& .MuiToggleButtonGroup-grouped': {
    border: 'none !important',
    borderColor: 'transparent !important',
    marginLeft: '0 !important'
  },
  '& .MuiToggleButtonGroup-firstButton, & .MuiToggleButtonGroup-middleButton, & .MuiToggleButtonGroup-lastButton': {
    border: 'none !important',
    borderColor: 'transparent !important',
    marginLeft: '0 !important'
  }
};

export const slidingToggleButtonNoBorder = {
  border: 'none !important',
  borderColor: 'transparent !important',
  outline: 'none',
  boxShadow: 'none',
  '&.Mui-selected, &.Mui-selected:hover, &:hover, &.Mui-focusVisible, &:focus, &.Mui-disabled': {
    border: 'none !important',
    borderColor: 'transparent !important',
    boxShadow: 'none'
  }
};
